import { useContext } from 'react'

import {
  Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import usePublications from '@hooks/usePublications'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PublicationTile from '@components/PublicationTile'

const MODAL_KEY = 'SelectPublicationModal'

type ModalPayload = {
  callbacks: {
    selectPublicationId: (payload: HandleCallbackActionParams) => void,
  },
  currentEditionId: number,
  publicationId: number,
}

type ModalCallbacks = {
  closeModal: () => void,
  selectPublicationId: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const SelectPublicationModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { closeModal } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload: ModalPayload = digObject(modalData, MODAL_KEY, {})
  const { callbacks: modalPayloadCallbacks } = modalPayload
  const { selectPublicationId } = modalPayloadCallbacks || {}

  // Load Publications
  const publicationsPayload = usePublications({
    performHttpRequests: true,
    requestOptions: {
      agency_publications_only: true,
      include_publication_logo: true,
    },
  })

  const { filteredPublications } = publicationsPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Select" titleSecondLine="Publication" />

      <SidebarModal.Content hasFooter={false}>
        <Form>
          <Form.Field label="Select Publication">
            {filteredPublications.map(publication => (
              <PublicationTile
                callbacks={{
                  selectPublication: () => {
                    if (selectPublicationId){
                      selectPublicationId({
                        // @ts-expect-error TS2741
                        callbacks: {
                          afterAction: closeModal,
                        },
                        entityParams: {
                          publication_id: publication.id,
                        },
                        toastText: 'Selected Publication',
                      })
                    }
                  },
                }}
                key={publication.id}
                publication={publication}
              />
            ))}
          </Form.Field>
        </Form>
      </SidebarModal.Content>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <SelectPublicationModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
